import { render, staticRenderFns } from "./ServiceSchedulePage.vue?vue&type=template&id=fd89d642&scoped=true&"
import script from "./ServiceSchedulePage.vue?vue&type=script&lang=ts&"
export * from "./ServiceSchedulePage.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceSchedulePage.vue?vue&type=style&index=0&id=fd89d642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd89d642",
  null
  
)

export default component.exports